import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { CurbLinkRecord } from "../../../interfaces/CurbLink";
import { GeometryInterface } from "../../../interfaces/Geometry";
import { proposedChangesFilterParams } from "../Listview/types";
import { ProposedRegulationReceived } from "../types";
import { LinkFeature } from "interfaces/Geoserver";

export const TOGGLE_BATCH_SELECTION = "TOGGLE_BATCH_SELECTION";
export const SET_CURRENT_BATCH = "SET_CURRENT_BATCH";
export const STORE_BATCH_LINKS = "STORE_BATCH_LINKS";
export const GET_LINKS_IN_BATCH = "GET_LINKS_IN_BATCH";
export const STORE_BATCH_SHAPES = "STORE_BATCH_SHAPES";
export const SHOW_BATCH_LIST_VIEW = "SHOW_BATCH_LIST_VIEW";
export const SET_SELECTED_BATCH_IDS = "SET_SELECTED_BATCH_IDS";
export const SET_SELECTED_BATCH_REGULATIONS = "SET_SELECTED_BATCH_REGULATIONS";
export const GET_BATCH_REGULATIONS = "GET_BATCH_REGULATIONS";
export const GET_DELETE_BATCH_REGULATIONS = "GET_DELETE_BATCH_REGULATIONS";
export const DELETE_BATCH_REGULATION = "DELETE_BATCH_REGULATION";
export const TOGGLE_BATCH_ACTION_PERFORMED = "TOGGLE_BATCH_ACTION_PERFORMED";
export const BATCH_REGULATIONS_RECEIVED = "BATCH_REGULATIONS_RECEIVED";
export const HIGHLIGHTED_BATCH_LINKS = "HIGHLIGHTED_BATCH_LINKS";
export const SELECTED_BATCH_COLUMNS = "SELECTED_BATCH_COLUMNS";

export interface BatchLinks {
    [uuid: string]: {
        links: (CurbLinkRecord | LinkFeature)[];
        assets?: any;
    };
}

export interface HighlightedBatchLinks {
    [uuid: string]: { id: number; geometry: GeometryInterface; display_name?: string }[];
}

export interface BatchShapes {
    [uuid: string]: {
        type: string;
        properties: { shape?: string };
        geometry: GeometryInterface;
    }[];
}

export interface LinksInBatch {
    subZone: {
        type: string;
        properties: {};
        geometry: GeometryInterface;
    };
    uuid: string;
}

export interface BatchListDataType {
    action: string;
    batch: { id: number };
    created: string;
    curb_link: { id: number; bl_street_name: string };
    custom_link: number;
    id: number;
    proposedId: number;
    published_on: string;
    regulationId: string;
    sub_activity: { name: string; activity: { name: string } };
    user: { first_name: string };
}

export interface setCurrentBatchAction {
    type: typeof SET_CURRENT_BATCH;
    payload: { currentBatch: string | null };
}

export interface toggleBatchSelectionAction {
    type: typeof TOGGLE_BATCH_SELECTION;
    payload: { isEnabled: boolean };
}

export interface storeBatchLinksAction {
    type: typeof STORE_BATCH_LINKS;
    payload: { batchLinks: BatchLinks };
}

export interface storeBatchShapesAction {
    type: typeof STORE_BATCH_SHAPES;
    payload: { batchShapes: BatchShapes };
}

export interface selectedBatchColumnsActions {
    type: typeof SELECTED_BATCH_COLUMNS;
    payload: { selectedColumns: string[] };
}

export interface highlightedBatchLinksAction {
    type: typeof HIGHLIGHTED_BATCH_LINKS;
    payload: {
        highlightedBatchLinks: HighlightedBatchLinks;
    };
}

export interface getLinksInBatchAction {
    type: typeof GET_LINKS_IN_BATCH;
    payload: LinksInBatch;
}

export interface showBatchListViewAction {
    type: typeof SHOW_BATCH_LIST_VIEW;
    payload: { shouldShowBatchListView: boolean };
}

export interface setSelectedBatchIdsAction {
    type: typeof SET_SELECTED_BATCH_IDS;
    payload: { selectedBatchData: ProposedRegulationReceived };
}

export interface setSelectedBatchRegulationsAction {
    type: typeof SET_SELECTED_BATCH_REGULATIONS;
    payload: {
        selectedRows: number[];
        selectedRegulationIds: number[];
        selectedProposedIds: number[];
        selectedIds: number[];
        selectedRowsActions: string[];
    };
}

export interface getBatchRegulationsAction {
    type: typeof GET_BATCH_REGULATIONS;
    payload?: { params?: proposedChangesFilterParams };
}

export interface getDeleteBatchRegulationAction {
    type: typeof GET_DELETE_BATCH_REGULATIONS;
    payload: { params: proposedChangesFilterParams };
}

export interface ToggleBatchActionPerformedAction {
    type: typeof TOGGLE_BATCH_ACTION_PERFORMED;
}

export interface DeleteBatchRegulationAction {
    type: typeof DELETE_BATCH_REGULATION;
    payload: { ids: number[]; params?: proposedChangesFilterParams; afterDelete?: () => void };
}

export interface batchRegulationsReceivedAction {
    type: typeof BATCH_REGULATIONS_RECEIVED;
    payload: { data: ProposedRegulationReceived[] };
}

export type BatchSelectionTypes =
    | toggleBatchSelectionAction
    | setCurrentBatchAction
    | storeBatchLinksAction
    | getLinksInBatchAction
    | selectedBatchColumnsActions
    | storeBatchShapesAction
    | showBatchListViewAction
    | setSelectedBatchIdsAction
    | setSelectedBatchRegulationsAction
    | highlightedBatchLinksAction
    | batchRegulationsReceivedAction
    | getBatchRegulationsAction
    | DeleteBatchRegulationAction
    | ToggleBatchActionPerformedAction
    | ResetStateAction
    | getDeleteBatchRegulationAction;

export interface BatchSelectionState {
    isBatchSelectionEnabled: boolean;
    currentBatch: string | null;
    batchLinks: BatchLinks;
    batchShapes: BatchShapes;
    highlightedBatchLinks: HighlightedBatchLinks;
    shouldShowBatchListView: boolean;
    selectedBatchData: ProposedRegulationReceived;
    selectedRowIds: number[];
    batchRegulations: ProposedRegulationReceived[];
    isFetchingBatchRegulations: boolean;
    actionPerformed: boolean;
    selectedColumns: string[];
    selectedIds: number[];
    selectedProposedIds: number[];
    selectedRegulationIds: number[];
    selectedRowActions: string[];
}
